module.exports = __webpack_public_path__ + "static/logo-8afc394094d4c67374f13229f58faf1c.png";